<template>
  <div>
    <v-row>
      <v-col>
        <Titulo
          :titulo="'Alteração de cliente'"
        />
      </v-col>
    </v-row>
    
    <v-row>
      <v-col lg="6">
        <v-card
          :class="'rounded-xl ' + (isMobile ? 'pa-3' : 'pa-6')"
          outlined
        >
          <v-card-text>
            <FormCliente
              :cliente="cliente"
              @on-submit="grava"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Titulo from '@/components/geral/Titulo'
import FormCliente from './FormCliente'

export default {
  data(){
    return {
      isMobile: false,
      id: 0,
      cliente: {}
    }
  },

  components: {
    Titulo,
    FormCliente
  },

  methods: {
    grava(form){
      const payload = {
        id: this.id,
        cliente: form
      }
      this.$store.dispatch('alteraCliente', payload)
      .then(() => {
        this.$router.go(-1)
      })
    }
  },

  created(){
    this.isMobile = window.innerWidth < 800
    this.id = Number(this.$route.params.id_cliente)
    this.$store.dispatch('buscaClientePorId', this.id)
    .then(() => {
      this.cliente = this.$store.getters.cliente
    })
  }
}
</script>

<style>

</style>